module.exports = __webpack_public_path__ + "static/servicii-casierie-large.92aefec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/servicii/servicii-casierie-large.jpg
// module id = 467
// module chunks = 51230292354760